<template>
<el-dialog :title="!dataForm.id ? '新增' : '修改'" :close-on-click-modal="false" width="40%" :visible.sync="viewData.visible">
    <el-form :model="dataForm" ref="dataForm" @keyup.enter.native="dataFormSubmit()" size="small" label-width="0px" class="org-dialog-form">
        <div class="des_box">
            <el-descriptions class="margin-top" :column="1" size="small" border style="margin-bottom: 15px;">
                <el-descriptions-item label="采购组织编码:" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item style="margin-bottom: 0;" prop="purchaseOrgCode">
                        <span v-if="viewFlag === 'view'">{{dataForm.purchaseOrgCode}}</span>
                        <el-input v-else v-model="dataForm.purchaseOrgCode" placeholder="采购组织编码" size="small" maxlength="10"></el-input>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="采购组织名称:" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item style="margin-bottom: 0;" prop="purchaseOrgName">
                        <span v-if="viewFlag === 'view'">{{dataForm.purchaseOrgName}}</span>
                        <el-input v-else v-model="dataForm.purchaseOrgName" placeholder="采购组织名称" size="small"></el-input>
                    </el-form-item>
                </el-descriptions-item>
            </el-descriptions>
        </div>
        <el-row :gutter="40">
            <el-col :span="24" style="text-align:right;">
                <el-button size="small" @click="viewData.visible = false">
                    取消
                </el-button>
                <el-button v-if="viewFlag !== 'view'" size="small" type="primary" @click="dataFormSubmit()">
                    保存
                </el-button>
                <!-- <el-button v-if="viewFlag !== 'view'" size="small" type="success" @click="dataFormPublish()">
                    发布
                </el-button> -->
            </el-col>
        </el-row>
    </el-form>
</el-dialog>
</template>

<script>
import {
    getPurchaseOrgById,
    editPurchaseOrg,
    createPurchaseOrg
} from '@/controller/systemData'
import moment from 'moment'
// require('@/mock/mockContract');
export default {
    data() {
        return {
            viewData: {
                visible: false,
                width: ''
            },
            dataList: [],
            dataForm: {
                purchaseOrgCode: '',
                purchaseOrgName: '',
            },
        }
    },
    mounted() {},
    methods: {
        init(data, id) {
            console.log(id)
            // this.dataForm = data ? data : this.dataForm
            this.dataForm.id = id || 0
            this.viewData.visible = true
            this.$nextTick(() => {
                this.$refs['dataForm'].resetFields()
                if (this.dataForm && this.dataForm.id) {
                    getPurchaseOrgById({}, this.dataForm.id).then(data => {
                        console.log(data)
                        if (data && data.code === '00') {
                            this.dataForm = data.body;
                        }
                    })
                }
            })
        },
        dateFormat: function (row, column) {
            var date = row[column.property]
            if (!date) {
                return ''
            }
            return moment(date).format("YYYY-MM-DD前")
        },
        dateFormatValue: function (value) {
            if (!value) {
                return ''
            }
            return moment(value).format("YYYY-MM-DD")
        },
        // 表单提交
        dataFormSubmit() {
            this.$refs['dataForm'].validate((valid) => {
                if (valid) {
                    let params = {
                        'id': this.dataForm.id || undefined,
                        'purchaseOrgCode': this.dataForm.purchaseOrgCode,
                        'purchaseOrgName': this.dataForm.purchaseOrgName,
                    }
                    if (this.dataForm.id) {
                        editPurchaseOrg(params).then(data => {
                            if (data && data.code === '00') {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    onClose: () => {
                                        this.viewData.visible = false
                                        this.$emit('refreshDataList')
                                    }
                                })
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    } else {
                        createPurchaseOrg(params).then(data => {
                            if (data && data.code === '00') {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    onClose: () => {
                                        this.viewData.visible = false
                                        this.$emit('refreshDataList')
                                    }
                                })
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    }
                }
            })
        },
        getStyle() {
            return 'width: 120px; text-align: right'
        },
        getStyle2() {
            return 'width: 455.5px;'
        }
    }
}
</script>
